import { render } from "./BorderModal.vue?vue&type=template&id=5a4cc250&scoped=true"
import script from "./BorderModal.vue?vue&type=script&lang=js"
export * from "./BorderModal.vue?vue&type=script&lang=js"

import "./BorderModal.vue?vue&type=style&index=0&id=5a4cc250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4cc250"]])

export default __exports__